import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export const surveyItemsState = {
   name: 'admin.surveyItems',
   url: '/surveyitems',
   templateUrl: require('./survey-items.html'),
   controller: 'SurveyItemsController as ctrl',
   data: {
      roles: 'SuperAdmin'
   }
};

export const validateSurveyState = {
   name: 'admin.validateXml',
   url: '/validatexml',
   roles: 'SuperAdmin',
   templateUrl: require('./validate-survey.html'),
   controller: 'ValidateSurveyController as ctrl'
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(surveyItemsState);
   $stateRegistry.register(validateSurveyState);
}
